import { render, staticRenderFns } from "./List-Branches.vue?vue&type=template&id=12e80cba&scoped=true"
import script from "./List-Branches.vue?vue&type=script&lang=js"
export * from "./List-Branches.vue?vue&type=script&lang=js"
import style0 from "./List-Branches.vue?vue&type=style&index=0&id=12e80cba&prod&lang=scss"
import style1 from "./List-Branches.vue?vue&type=style&index=1&id=12e80cba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e80cba",
  null
  
)

export default component.exports